import styled from 'styled-components';
import Badge from 'components/Badge';
import CopyToClipboardButton from 'components/CopyToClipboardButton';
import {
    GREY_100,
    GREY_400,
    GREY_600,
    PURPLE_500,
    PURPLE_700,
    WHITE,
} from '../../constants';

export const ChipWrap = styled.span<{ $fill?: boolean }>`
    position: relative;
    display: ${(props) => (props.$fill ? 'flex' : 'inline-flex')};
    flex-shrink: 0;
    width: ${(props) => (props.$fill ? '100%' : 'auto')};
    max-width: 100%;
    vertical-align: middle;
`;

export const StyledPaidBadge = styled(Badge)`
    user-select: none;
    cursor: pointer;
    padding: 0.25rem 0.5rem 0.25rem 0.375rem;
    line-height: 1;

    svg {
        width: 1rem !important;
        height: 1rem !important;
    }
`;

export const ChipButton = styled.button`
    && {
        display: inline-flex;
        align-items: center;
        height: auto;
        min-height: 0;
        max-width: 16rem;
        margin: 0;
        padding: 0;
        border: 0;
        background: transparent;
        color: ${GREY_600};
        cursor: pointer;
        font-size: 0.75rem;
        font-weight: 400;
        line-height: 1.25rem;
        white-space: nowrap;
        text-decoration: none;
    }
`;

export const MessageAdButton = styled.button`
    && {
        display: flex;
        align-items: center;
        gap: 0.625rem;
        width: 100%;
        height: auto;
        min-height: 0;
        margin: 0 0 0.5rem;
        padding: 0.5rem 0.75rem 0.5rem 0.5rem;
        border: 0;
        border-radius: 0.75rem;
        background: ${WHITE};
        color: #4B465C;
        cursor: pointer;
        text-align: left;

        svg {
            width: 1rem;
            height: 1rem;
            margin: 0;
        }
    }
`;

export const MessageAdIcon = styled.span`
    display: flex;
    flex: none;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border-radius: 999px;
    background: ${PURPLE_500};
    color: ${WHITE};
`;

export const MessageAdCopy = styled.span`
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 0;
`;

export const MessageAdLabel = styled.span`
    color: ${PURPLE_500};
    font-size: 0.75rem;
    font-weight: 700;
    line-height: 1rem;
`;

export const MessageAdTitle = styled.span`
    overflow: hidden;
    color: #4B465C;
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.25rem;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const MessageAdChevron = styled.span`
    display: flex;
    flex: none;
    color: ${PURPLE_500};
`;

export const DropDown = styled.div`
    display: flex;
    width: 23.75rem;
    padding: 1rem 1.25rem 1.25rem 1.25rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
    border-radius: 1.5rem;
    background: ${WHITE};
    box-shadow: 0px 4px 16px 0px rgba(75, 70, 92, 0.10);
`;

export const DropDownTitle = styled.h2`
    margin: 0;
    color: #4B465C;
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.625rem;
`;

export const InfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    width: 100%;
    padding: 1rem;
    align-items: flex-start;
    border-radius: 0.75rem;
    background: #F5F5F6;
`;

export const AdImage = styled.img`
    width: 100%;
    height: 8rem;
    object-fit: cover;
    border-radius: 0.75rem;
    background: ${GREY_100};
`;

export const AdText = styled.p`
    margin: 0;
    color: #4B465C;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.25rem;
`;

export const AdIdRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    width: 100%;
    min-width: 0;
`;

export const AdIdText = styled.span`
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 0;
`;

export const AdIdLabel = styled.span`
    color: ${GREY_400};
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1rem;
`;

export const AdIdValue = styled.span`
    overflow: hidden;
    color: #4B465C;
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1.25rem;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const StyledCopyToClipboardButton = styled(CopyToClipboardButton)`
    width: 2rem;
    height: 2rem;
    min-width: 2rem;
`;

export const OpenAdLink = styled.a`
    color: ${PURPLE_500};
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.5rem;
    white-space: nowrap;
    text-decoration: none;

    &:hover {
        color: ${PURPLE_700};
        text-decoration: underline;
    }
`;

export const CustomerBanner = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.5rem 0;
    color: ${GREY_600};
    font-size: 0.8125rem;
`;
